import FormBase from "../FormBase";
import Professional from '../../models/Professional'
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import PatientService from "../../services/PatientService";
import { InternacaoOptions } from "../../data/Internacao";
import { TipoInternacaoOptions } from "../../data/TipoInternacao";

export default class PatientForm implements FormBase {

    Name: FormFieldBase;
    BirthDate: FormFieldBase;
    RG: FormFieldBase;
    CPF: FormFieldBase;
    ExpectedDateReception: FormFieldBase;
    TimePermanenceInDays: FormFieldBase;
    ServiceType: FormFieldBase;
    HospitalType: FormFieldBase;
    DiagnosticHypothesis: FormFieldBase;
    Procedure: FormFieldBase;
    HealthInsurance: FormFieldBase;
    Category: FormFieldBase;
    Plan: FormFieldBase;


    constructor(CPF: string, Name: string, RG: string, ExpectedDateReception: string, TimePermanenceInDays: string,
        Hospitalization: string, HospitalizationType: string, DiagnosticHypothesis: string,
        Procedure: string, HealthInsurance: string, Category: string, Plan: string, BirthDate?: Date) {

        this.CPF = new FormFieldBase(CPF, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CPF)]);
        this.Name = new FormFieldBase(Name, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.RG = new FormFieldBase(RG, [new ValidationBase("", ValidationType.RG)]);
        this.BirthDate = new FormFieldBase(BirthDate, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.DATANASCIMENTO), new ValidationBase("A data de nascimento informada é inválida.", ValidationType.DATA)]);
        this.ExpectedDateReception = new FormFieldBase(ExpectedDateReception, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("A data prevista da internação informada é inválida.", ValidationType.DATA)]);
        this.TimePermanenceInDays = new FormFieldBase(TimePermanenceInDays, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.ServiceType = new FormFieldBase(Hospitalization, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.HospitalType = new FormFieldBase(HospitalizationType, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.DiagnosticHypothesis = new FormFieldBase(DiagnosticHypothesis, [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFiledDescriptionCustom(value) }));
        this.Procedure = new FormFieldBase(Procedure, [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFiledDescriptionCustom(value) }));
        this.HealthInsurance = new FormFieldBase(HealthInsurance, [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFieldCustom(value) }));
        this.Category = new FormFieldBase(Category, [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFieldCustom(value) }));
        this.Plan = new FormFieldBase(Plan, [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFieldCustom(value) }));
    }

    static NewInstance(): PatientForm {
        return new PatientForm("", "", "", "", "", "", "", "", "", "", "", "");
    }

    ValidateFieldCustom(value: any): string {
        if (this.ServiceType.Value === "Convenio" && value === "") {
            return "O Campo é obrigatório."
        } else {
            return "";
        }
    }

    ValidateFiledDescriptionCustom(value: any): string {
        
        if(value === ""){
            return "O Campo é obrigatório.";
        }else {
            var numbers = value.replace(/[^0-9]/g, ''); 
            var letters = value.replace(/[^A-Za-z]/g, ''); 
            if(numbers.length >= letters.length)
            {
                return "Por favor, descrever por extenso, não inserir apenas códigos.";
            }
        }
        
        return "";
    }

    ValidateToGoNextStep(): string {

        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return PatientService.postInsertOrUpdatePatient(dataJson, Professional.Id);
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Name":
                return this.Name
            case "BirthDate":
                return this.BirthDate
            case "RG":
                return this.RG
            case "CPF":
                return this.CPF
            case "ExpectedDateReception":
                return this.ExpectedDateReception
            case "TimePermanenceInDays":
                return this.TimePermanenceInDays
            case "ServiceType":
                return this.ServiceType
            case "HospitalType":
                return this.HospitalType
            case "DiagnosticHypothesis":
                return this.DiagnosticHypothesis
            case "Procedure":
                return this.Procedure
            case "HealthInsurance":
                return this.HealthInsurance
            case "Category":
                return this.Category
            case "Plan":
                return this.Plan
            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {


        return {
            "professionalId": 0,
            "name": this.Name.Value,
            "birthDate": this.BirthDate.Value,
            "rg": this.RG.Value,
            "cpf": this.CPF.Value,
            "expectedDateReception": this.ExpectedDateReception.Value,
            "timePermanenceInDays": parseInt(this.TimePermanenceInDays.Value),
            "serviceType": InternacaoOptions.find(r => r.value === this.ServiceType.Value)?.id,
            "hospitalType": TipoInternacaoOptions.find(r => r.value === this.HospitalType.Value)?.id,
            "diagnosticHypothesis": this.DiagnosticHypothesis.Value,
            "healthInsurance": this.HealthInsurance.Value,
            "procedureName": this.Procedure.Value,
            "category": this.Category.Value,
            "plan": this.Plan.Value

        }
    }
}